'use client';

import { useTranslation } from 'react-i18next';

import type { ClassCancellationPolicy } from '../_lib/class-cancellation-policy';

export function ClassCancellationDisclosure({
  policy,
}: {
  policy: ClassCancellationPolicy | null | undefined;
}) {
  const { t } = useTranslation('bookings');

  return (
    // Fine print under the pay button (BookingPolicyNotice summary), styled
    // by its host; the "cancellation policy" link beside it opens the detail.
    <p data-test="class-cancellation-policy">
      {!policy
        ? t('classPolicyUnavailable')
        : policy.isNonRefundable
          ? t('classPolicyNoRefunds')
          : t(
              policy.cancellationWindowHours === 0
                ? 'classPolicyCreditAnytime'
                : 'classPolicyCreditWindow',
              {
                window: t('policyHours', {
                  count: policy.cancellationWindowHours,
                }),
              },
            )}
    </p>
  );
}
